import { Component, OnInit } from '@angular/core';
import {SelectablesService} from '../selectables.service'
import { Consignor } from '../selectable-schema';
import { ActivatedRoute, Router,NavigationExtras } from '@angular/router';
import { ConsignorService } from '../_services/_masters/consignor.service';

declare var $ : any;

const user_role = JSON.parse(localStorage.getItem('currentUser'));

@Component({
  selector: 'app-clients',
  templateUrl: './clients.component.html',
  styleUrls: ['./clients.component.css']
})
export class ClientsComponent implements OnInit {

	consignors: Consignor[];
	public consignor_name:any;
	branch : any = null ;
	loading_point : string = 'rail';
	godown_to : string = 'gatepass';

	constructor( 
			private selectClientService : SelectablesService, 
			private selectConsignorService : ConsignorService,
			private selectablesService : SelectablesService,
			private route: ActivatedRoute,
			private router : Router
		) { 
		router.events.subscribe((val) => {
			this.branch = null;
			this.route.params.subscribe(params => { this.branch = params.branch});

			if ((this.branch == "all") && (user_role["role"] == "Admin")) 
			{
				this.getAllConsigner();
				console.log("ALL" + this.branch);
			}
			else if ((user_role["role"] != "Admin") && (this.branch == "all"))
			{	
				this.branch = user_role["branch"]
				this.getConsignorBySelectedBranch(this.branch);
				console.log( "specific" + this.branch);
			}
			else
			{
				this.getConsignorBySelectedBranch(this.branch);
				console.log( "specific" + this.branch);
			}

		})
	}

	ngOnInit() {
		// this.branch = null;
		// this.route.params.subscribe(params => { this.branch = params.branch});
		// if (this.branch == "all") {
		// 	this.getAllClients();
		// 	console.log(this.branch);
		// }
		// else{
		// 	this.getOnlyClients(this.branch);
		// 	console.log(this.branch);
		// }
		
		localStorage.removeItem("form_info");
	}

	getAllConsigner()
	{
		this.selectConsignorService.getAllConsignor()
		.subscribe(
			consigners => {
				console.log(consigners);
				this.consignors = consigners;
			});
	};

	getOnlyConsignerBranch(branch){
		this.selectConsignorService.getConsignorFormWithBranch(branch)
		.subscribe(
			clients => {
				console.log(clients);
				this.consignors = clients;
			});
	};
	getConsignorBySelectedBranch(branch)
    {
    	this.consignors=[];
     	this.selectConsignorService.getConsignorFormWithBranch(branch)
		.subscribe(
			consignors => {
				//alert(consignors);
				this.consignors=consignors;
				// for(var i=0;i<consignors.length;i++)
				// {
				// 	this.consignors.push(consignors[i]['consignor_name']);
				// }
			});
    }


	loadingPoint(client:string,branch:string){
		this.selectablesService.setConsigner(client);
		this.selectablesService.getSelectedBranch(branch);
		$("#default-modal").modal('show');
	};

	selectLoadingPoint(point:string)
	{
		this.loading_point = point;
		console.log("SelectedLoadingPointClient :" + this.loading_point);
		this.selectClientService.getSelectedLoadPoint(this.loading_point)
		$("#default-modal").modal('hide');
		if (this.loading_point == 'godown'){
			$("#godown").modal('show');
		}
		else {
			this.selectClientService.by_godown = false;
			// let navigationExtras: NavigationExtras = {
   //          queryParams: {
   //              "firstname": "Nic",
   //              "lastname": "Raboy"
   //          }
   //      	};

			this.router.navigate(['rrform']);
		}
	};

	godownTo(point :string)
	{
		this.godown_to = point;
		// console.log(this.godown_to);
		this.selectClientService.getGodownToForm(this.godown_to);
		if (this.godown_to == 'lrform'){
			$("#godown").modal('hide');
			this.router.navigate(['lrform']);
		}
		else {
			$("#godown").modal('hide');
			this.router.navigate(['gatepass']);
		}
	};

}



// WEBPACK FOOTER //
// /Users/meghneel/work/shree_translogic_dashboard/src/app/clients/clients.component.ts